import { AppResponse } from '@/modules/core/interfaces/appResponse';
import AuthorizedApiClient from '@/modules/auth/models/authorizedApiClient';
import { AxiosResponse } from 'axios';
import { WhatsNew } from '../models/WhatsNew';
import { WhatsNewListResponse } from '../interfaces/whatsNew';

export interface ListResult {
  items: WhatsNew[];
  hasMore: boolean;
}

export class WhatsNewApi {
  public async list(page: number = 1, recordsPerPage: number = 10): Promise<ListResult> {
    const response: AxiosResponse<AppResponse<any>> =
      await AuthorizedApiClient.post('/whats-new/list', {
        page,
        recordsPerPage,
      });

    if (response.status === 200) {
      const apiResult: AppResponse<any> = response.data;
      if (apiResult.success && apiResult.data) {
        const d = apiResult.data;
        // Pagination structure: { data: [], hasNext/hasMore }
        if (d.data && Array.isArray(d.data)) {
          const listResponse: WhatsNewListResponse = d;
          const items = listResponse.data.map((item: any) => new WhatsNew(item));
          const hasMore = listResponse.hasNext !== undefined
            ? listResponse.hasNext
            : (listResponse.hasMore !== undefined ? listResponse.hasMore : items.length === recordsPerPage);
          return { items, hasMore };
        }
        // Plain array
        if (Array.isArray(d)) {
          const items = d.map((item: any) => new WhatsNew(item));
          return { items, hasMore: items.length === recordsPerPage };
        }
        // Some backends use { items: [] } or { content: [] } or { list: [] }
        const arr = d.items || d.content || d.list;
        if (arr && Array.isArray(arr)) {
          const items = arr.map((item: any) => new WhatsNew(item));
          const hasMore = d.hasNext !== undefined ? d.hasNext : (d.hasMore !== undefined ? d.hasMore : items.length === recordsPerPage);
          return { items, hasMore };
        }
      }
    }

    return { items: [], hasMore: false };
  }

  public async get(id: number): Promise<WhatsNew | null> {
    const response: AxiosResponse<AppResponse<WhatsNew>> =
      await AuthorizedApiClient.get(`/whats-new/${id}`);

    if (response.status === 200) {
      const apiResult: AppResponse<WhatsNew> = response.data;
      if (apiResult.success && apiResult.data) {
        return new WhatsNew(apiResult.data);
      }
    }

    return null;
  }
}
